import ConfigurationService from "src/services/configurationService";
import axios from "axios";
import ConfiguratorService from "src/services/configuratorService";
import CalculationService from "src/services/calculationService";

interface GetUUIDResponse {
    uuid: string;
}

class RequestService {
    private configurationService?: ConfigurationService;
    private configuratorService?: ConfiguratorService;
    private calculationService?: CalculationService;

    constructor(
        configuration: ConfigurationService,
        configurator: ConfiguratorService,
        calculation: CalculationService,
    ) {
        this.configurationService = configuration;
        this.configuratorService = configurator;
        this.calculationService = calculation;
    }

    async addOffer(formObject: any): Promise<any> {
        const screenshots = await this.configuratorService?.getScreenShots();
        formObject["screenshot1"] =
            screenshots && screenshots.length > 0 ? screenshots[0] : "";
        formObject["screenshot2"] =
            screenshots && screenshots.length > 1 ? screenshots[1] : "";
        formObject["screenshot3"] =
            screenshots && screenshots.length > 2 ? screenshots[2] : "";
        formObject["screenshot4"] =
            screenshots && screenshots.length > 3 ? screenshots[3] : "";
        formObject["screenshot5"] =
            screenshots && screenshots.length > 3 ? screenshots[4] : "";
        formObject["screenshot6"] =
            screenshots && screenshots.length > 3 ? screenshots[5] : "";
        formObject["total_price"] = this.calculationService?.calculateTotalPrice();
        formObject["configuration"] =
            this.configurationService?.getConfigurationHash();

        return await axios.post("/api/save.php", formObject, {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
    }

    async getOffer() {
        const params = new URLSearchParams(window.location.search);
        const uuid = params.get("offerte");
        let hash = null;

        if (uuid) {
            const formData = new FormData();
            formData.append('uuid', uuid)

            return await axios.post("/api/restore.php", formData, {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            });
        }

        return hash;
    }

    async getUUID() {
        const hash = this.configurationService?.getConfigurationHash();

        try {
            if (!hash) {
                return "";
            }

            const formData = new URLSearchParams();
            formData.append("hash", hash);

            const response = await axios.post<GetUUIDResponse>(
                "/api/getUUID.php",
                formData,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Accept: "application/json",
                    },
                },
            );

            return response.data?.uuid || "";
        } catch (error) {
            console.error("Error fetching UUID:", error);
            return "";
        }
    }

    addOrder = async () => {
        try {
            const screenshots = await this.configuratorService?.getScreenShots();
            const configuration = this.configurationService?.getConfiguration();
            const components = this.calculationService
                ?.getData()
                .filter((item: any) => item && item.quantity > 0)
                .map((item: any) => {
                    if (!item) return {name: "", price: 0, quantity: 0};
                    return {
                        name: item.label,
                        price: item.total,
                        quantity: item.quantity,
                    };
                });

            const formKey = (
                document.querySelector('input[name="form_key"]') as HTMLInputElement
            )?.value;

            if (!formKey) {
                throw new Error(`Form key is missing on the page.`);
            }

            const payload = {
                form_key: formKey,
                config_data: JSON.stringify({
                    total_price: configuration?.total_price ?? 0,
                    roofType: this.configurationService?.getRoofType(),
                    configuration:
                        this.configurationService?.getConfigurationHash() ?? "",
                    components: components,
                    screenshot1:
                        screenshots && screenshots.length > 0 ? screenshots[0] : "",
                    screenshot2:
                        screenshots && screenshots.length > 1 ? screenshots[1] : "",
                    screenshot3:
                        screenshots && screenshots.length > 2 ? screenshots[2] : "",
                    screenshot4:
                        screenshots && screenshots.length > 3 ? screenshots[3] : "",
                    screenshot5:
                        screenshots && screenshots.length > 3 ? screenshots[4] : "",
                    screenshot6:
                        screenshots && screenshots.length > 3 ? screenshots[5] : "",
                }),
            };

            const urlEncodedPayload = new URLSearchParams();

            for (const key in payload) {
                if (payload.hasOwnProperty(key)) {
                    urlEncodedPayload.append(
                        key,
                        payload[key as keyof typeof payload] as any,
                    );
                }
            }

            await axios.post(
                "/configurator/cart/add",
                urlEncodedPayload.toString(), // We pass data in the form of a string
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // We indicate the correct title
                    },
                },
            );

            window.location.href = "/checkout/cart/";
        } catch (error) {
            const errorMessage =
                error instanceof Error ? error.message : String(error);
            throw new Error(`Error adding product to cart: ${errorMessage}`);
        }
    };
}

export default RequestService;
